import { RegisterForm } from '../features/auth/components/RegisterForm';

export function RegisterPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="KI für Pflege" className="h-12 w-auto mx-auto mb-4" />
          <p className="text-muted-foreground">
            Nützliche Informationen für Pflegekräfte, <br />unterstützt durch Künstliche Intelligenz.
          </p>
        </div>

        <RegisterForm />
      </div>
    </div>
  );
}
